export default {
    greet_text: `Welcome to our platform. Here you can improve your reading skills in a very entertaining way.`,
    greet_text_2: 'Before starting we need you to complete your profile',
    greet_wellcome: 'Welcome',
    avatar_select: 'Select your Avatar:',
    continue: 'Continue',
    get_started: 'Get Started',
    categories_select: 'Select your preferred categories',
    msg_categories_not_select:
        'You have not selected any category, you must indicate at least one to continue.',
    finish: 'Finish',
    next_question: 'Next Question',
    previous_diagnostic_msg:
        '{username} we are about to finish, the last thing we need is to answer a diagnosis that will allow us more about your abilities.',
    questions: 'Questions:',
    finish_msg: "You're almost done!",
    pre_modal_msg: {
        msg_1: 'You already have your avatar and you have selected your preferred categories',
        msg_2: 'Now we need to know a little more about you by answering the following survey.',
    },
    excellent: 'Excellent',
    msg_thanks: 'Thank you very much!',
    msg_finish: 'Enjoy this new experience.',
    msg_survey_init: 'We are almost done',
    txt_survey_init: 'Before you start reading, answer the following survey.',
    tutorialTitle: 'Before starting this <br>diagnosis, you should know that:',
    steps_msgs: {
        msg_1:
            'This test contains <b> {count} texts </b> and <b> {countQuestions} questions </b> of alternatives.',
        msg_2:
            'The questions only <b> have a correct answer. </b> Therefore you should only select one alternative.',
        msg_3: '<b> Read carefully </b> each text to answer the questions that follow.',
        msg_4: "<b> Don't use dictionary </b> or other support",
    },
    select_option: 'You must select one of the options to continue',
    unable_save_diagnostics: 'Failed to save diagnostic answers',
    initialDiagnostic: 'Initial Diagnostic',
    beforeYouBegin: 'Before you start you should know',
    to_start_Br_first_test: 'To start at Beereaders, you must first take a test',
    eight_texts_forty_questions: 'This test contains 8 texts and 40 alternative questions',
    single_selection_questions:
        'The questions have only one correct answer, therefore, you should mark one alternative',
    readCarefully: 'Read carefully each text in order to answer its questions',
    noDictionary: "Don't use a dictionary or another type of help",
    successDiagnostic: '!You have finished the Reading Diagnostic successfully¡',
    readyToBegin: '¡Now you are ready to begin!',
    finishDiagnostic: 'Finish Diagnostic',
    return: 'Return',
    question: 'Question',
    of: 'of',
    next_text: 'Next text',
    finish_onboarding: 'You have finished everything correctly now you are ready to get started in BeeReaders'
}
